import m from './module';
import Product from '../model/Product';

const path = '/product';
const type = 'Product';

class ProductService {
  constructor($q, DataSyncService, RoleVariableService, LocationService) {
    "ngInject";
    this.$q = $q;
    this.DataSyncService = DataSyncService;
    this.RoleVariableService = RoleVariableService;
    this.LocationService = LocationService;
  }

  create(data) {
    return new Product(data);
  }

  getAll(config = null) {
    return this.DataSyncService.getMultipleObjects(type, path, obj => this.create(obj), config);
  }

  getById(id, config = null) {
    return this.DataSyncService.getObjectByIdFromMultiple(type, path, id, obj => this.create(obj), config);
  }

  serialize(product, formId) {
    return {
      id: product.id,
      location_variable_ids: product.location_variables.map(lv => lv.id),
      role_variables: product.role_variables.map(rv => this.RoleVariableService.serialize({ ...rv, events_custom_forms_products_id: formId })),
      locations: product.locations.map(loc => this.LocationService.serialize({ ...loc, events_custom_forms_products_id: formId }))
    };
  }
}

export default ProductService;

m.service('ProductService', ProductService);
